import AttendanceStudentList from "@/controllers/attendance_student/attendance-student-list.js";

export default {
  extends: AttendanceStudentList,
};
